export const hasConstructor = (f) => {
  if (!f) {return false}
  try {
    Reflect.construct(String, [], f)
  } catch (e) {
    return false
  }
  return true
}
